import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import username from 'flarum/common/helpers/username';
import userOnline from 'flarum/common/helpers/userOnline';
import Link from 'flarum/common/components/Link';
import classList from 'flarum/common/utils/classList';
import SelectBestAnswerItem from './SelectBestAnswerItem';
import ItemList from 'flarum/common/utils/ItemList';
import humanTime from 'flarum/common/helpers/humanTime';
export default class BestAnswerFooterPreview extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "user", void 0);
    _defineProperty(this, "post", void 0);
    _defineProperty(this, "discussion", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.user = this.attrs.user;
    this.post = this.attrs.post;
    this.discussion = this.attrs.discussion;
  }
  view() {
    const maxLines = app.forum.attribute('fof-best-answer.show_max_lines');
    return m("div", {
      className: "CommentPost",
      onclick: () => app.current.get('stream').goToNumber(this.post.number())
    }, m("div", {
      className: "Post-header"
    }, m("ul", null, this.headerItems().toArray())), m("div", {
      className: classList('Post-body', maxLines > 0 && 'Post-body--truncate'),
      style: {
        '--max-lines': maxLines
      }
    }, m.trust(this.postContent())));
  }
  postContent() {
    return this.post.contentHtml();
  }

  /**
   * To maintain compatibility with existing styling, custom themes, etc, each item here must be
   * wrapped in a <li> element.
   *
   * @todo: Remove this requirement for Flarum 2.0
   */
  headerItems() {
    const items = new ItemList();
    items.add('user', this.userItem()), 100;
    items.add('meta', this.metaItem()), 90;
    items.add('bestAnswer', m(SelectBestAnswerItem, {
      post: this.post,
      discussion: this.discussion
    }), -100);
    return items;
  }
  userItem() {
    return m("li", {
      className: "item-user"
    }, m("div", {
      className: "PostUser"
    }, m("h3", {
      className: "PostUser-name"
    }, this.user && userOnline(this.user), this.user ? m(Link, {
      href: app.route.user(this.user)
    }, username(this.user)) : username(this.user))));
  }
  metaItem() {
    const post = this.post;
    return m("li", {
      className: "item-meta"
    }, m("span", {
      className: "PostMeta-time"
    }, humanTime(post.createdAt())));
  }
}
flarum.reg.add('fof-best-answer', 'forum/components/BestAnswerFooterPreview', BestAnswerFooterPreview);